'use client'

import { useEffect } from 'react'

declare global {
    interface Window {
        googletag?: any // Replace with correct typings if using @types/googletag
    }
}

interface CategoryTrackerProps {
    currentCategory: string
}

const COOKIE_NAME = 'qz_reader_category'
const MAX_COOKIE_AGE_DAYS = 30

const gamCategories = [
    'ai',
    'airlines',
    'autos',
    'business-news',
    'cars',
    'cloud-computing',
    'collecting',
    'cybersecurity',
    'earnings-snapshots',
    'economic-indicators',
    'emerging-technologies',
    'food',
    'food-fine-dining',
    'future-of-work',
    'health-fitness',
    'leadership',
    'lifestyle',
    'markets',
    'money-markets',
    'news',
    'personal-finance',
    'pharma',
    'politics-government',
    'real-estate',
    'retail',
    'smart-investing',
    'space',
    'tech-innovation',
    'travel',
]

const setGamKv = (key: string, value: string | Array<string>) => {
    window['googletag'] = window['googletag'] || { cmd: [] }
    window['googletag'].cmd.push(() => {
        window['googletag']?.pubads().setTargeting(key, value)
    })
}

const getCookie = (name: string): string | null => {
    const regex = new RegExp('(?:^|; )' + name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)')
    const match = document.cookie.match(regex)
    return match && match[1] ? decodeURIComponent(match[1]) : null
}

const setCookie = (name: string, value: string, days: number): void => {
    const expires = new Date()
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`
}

const normalizeCategory = (category: string = '') => {
    return category.replace(/[ &.]/g, '-').toLowerCase()
}

export const CategoryTracker: React.FC<CategoryTrackerProps> = ({ currentCategory }) => {
    const normalizedCategory = normalizeCategory(currentCategory)
    useEffect(() => {
        const raw = getCookie(COOKIE_NAME)
        const categories = new Set<string>(
            raw
                ?.split(',')
                .map((c) => c.trim())
                .filter(Boolean) || [],
        )

        if (currentCategory && !categories.has(normalizedCategory)) {
            categories.add(normalizedCategory)
            setCookie(COOKIE_NAME, Array.from(categories).join(','), MAX_COOKIE_AGE_DAYS)
        }

        const matched = [...categories].filter((c) => gamCategories.includes(c))
        if (matched.length > 0) {
            setGamKv('qz_reader_category', Array.from(categories))
        }
    }, [currentCategory])

    return null
}
